import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { Security } from '../utils/security.util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class AccountService {
    constructor(http) {
        this.http = http;
    }
    composeHeaders() {
        const token = Security.getToken();
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return headers;
    }
    getHearderAuthorization() {
        return {
            "Authorization": `Bearer ${Security.getToken()}`
        };
    }
    authenticate(data) {
        const dt = 'grant_type=password&username=' + data.username + '&password=' + data.password;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        return this.http.post(`${SCAMP_API.accountApiV1}/authenticate`, dt, { headers });
    }
    getUsers() {
        return this.http.get(`${SCAMP_API.accountApiV1}/users`, { headers: this.composeHeaders() });
    }
    getUsersById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/users/${id}`, { headers: this.composeHeaders() });
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/users`, data, { headers: this.composeHeaders() });
    }
    update(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/users/${data.id}`, data, { headers: this.composeHeaders() });
    }
    removeUser(data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/users/remove/${data.id}`, data, { headers: this.composeHeaders() });
    }
}
AccountService.ngInjectableDef = i0.defineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.inject(i1.HttpClient)); }, token: AccountService, providedIn: "root" });
